import { FunctionComponent } from 'react'
import { Link, useNavigate } from 'react-router-dom'
import { Navbar, Nav, NavDropdown } from 'react-bootstrap'

import classnames from 'classnames'
import headerCss from './header.module.scss'
import logo from 'assets/images/logo.png'
import { UserRole } from 'features/user/types'
import {
  getHospitalAdmin,
  getHospitalSynchronizedAt,
  getUserProfile,
  getUsername,
  parseHospitalSynchronizedAtMs,
} from '../../features/user/auth'

const formatSincronizedAt = (raw: string | null): string | null => {
  const millis = parseHospitalSynchronizedAtMs(raw)

  if (millis === null) {
    return null
  }

  const date = new Date(millis)

  if (Number.isNaN(date.getTime())) return null
  return date.toLocaleString('pt-BR', {
    day: '2-digit',
    month: '2-digit',
    year: 'numeric',
    hour: '2-digit',
    minute: '2-digit',
  })
}

/**
 * Header used when the user is logged in
 */
const Header: FunctionComponent<{ logout: () => void }> = ({ logout }) => {
  const navigate = useNavigate()

  const isUserDoctor = (): boolean => getUserProfile() === UserRole.DOCTOR

  const isUserHospitalAdmin = (): boolean =>
    getUserProfile() === UserRole.HOSPITAL_ADMIN

  const isUserAdmin = (): boolean => getUserProfile() === UserRole.ADMIN

  const hospitalSyncLabel =
    isUserHospitalAdmin() && formatSincronizedAt(getHospitalSynchronizedAt())

  const openDoctorPage = () => navigate('/doctor')

  return (
    <Navbar expand="lg" className={headerCss.customNavBar}>
      <Navbar.Brand href="#" className={headerCss.navbarBrand}>
        <span className={headerCss.brandPrimary}>
          <img
            src={logo}
            width="30"
            height="30"
            className={classnames('d-inline-block', headerCss.brandLogo)}
            alt="Clic-repasse"
          />
          <span className={headerCss.brandMain}>Clic-repasse</span>
        </span>
        {isUserHospitalAdmin() && (
          <span className={headerCss.hospitalBlock}>
            <b className={headerCss.hospitalName}>{getHospitalAdmin()}</b>
            {hospitalSyncLabel ? (
              <span className={headerCss.hospitalSyncAt}>
                Atualizado: {hospitalSyncLabel}
              </span>
            ) : null}
          </span>
        )}
      </Navbar.Brand>

      <Nav className={classnames('mr-auto', headerCss.customNav)}>
        {(isUserDoctor() || isUserHospitalAdmin()) && (
          <Link
            className={classnames('nav-link', headerCss.customNavLink)}
            to="/transfers"
          >
            Repasses
          </Link>
        )}
        {(isUserDoctor() || isUserAdmin()) && (
          <Link
            className={classnames('nav-link', headerCss.customNavLink)}
            to="/hospitals"
          >
            Hospitais
          </Link>
        )}

        {isUserAdmin() && (
          <>
            <Link
              className={classnames('nav-link', headerCss.customNavLink)}
              to="/doctors"
            >
              Médicos
            </Link>

            <Link
              className={classnames('nav-link', headerCss.customNavLink)}
              to="/users"
            >
              Usuários
            </Link>
          </>
        )}

        {isUserHospitalAdmin() && (
          <Link
            className={classnames('nav-link', headerCss.customNavLink)}
            to="/access-requests"
          >
            Solicitações de acesso
          </Link>
        )}
        {isUserHospitalAdmin() && (
          <Link
            className={classnames('nav-link', headerCss.customNavLink)}
            to="/doctors"
          >
            Médicos
          </Link>
        )}
      </Nav>
      <Navbar.Collapse id="nva-user-name" className="justify-content-end">
        <Nav>
          <NavDropdown id="user-name" title={getUsername()} align={'end'}>
            <NavDropdown.Item href="#">Minha conta</NavDropdown.Item>
            {isUserDoctor() && (
              <NavDropdown.Item href="#" onClick={openDoctorPage}>
                Meus dados
              </NavDropdown.Item>
            )}
            <NavDropdown.Divider />
            <NavDropdown.Item href="#" onClick={logout}>
              Sair
            </NavDropdown.Item>
          </NavDropdown>
        </Nav>
      </Navbar.Collapse>
    </Navbar>
  )
}

export default Header
